// ===============================================================
// FORMAT MONEY
// ===============================================================
export function formatMoney(value) {
  // FORMATA UM VALOR
  return (
    'R$ ' +
    value
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+\,)/g, '$1.')
  );
}

// ===============================================================
// URL ENCODE FORM DATA
// ===============================================================
export function urlencodeFormData(formData) {
  let string = '';

  function encode(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
  }

  for (const pair of formData.entries()) {
    if (typeof pair[1] == 'string') {
      string += (string ? '&' : '') + encode(pair[0]) + '=' + encode(pair[1]);
    }
  }
  return string;
}

// ===============================================================
// VALIDATE FORM PRODUCT
// ===============================================================
export function validateFormProduct(_$form){
  // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest("[data-box-produto]");
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errorsTxt = [];

    console.log($btnComprar.data("available"));

    //  verifica se o sku foi selecionado
    if (_$form.find('[name="sku"]').val() == "") {
      validated = false;
      errorsTxt.push("Selecione um atributo para o produto");
    }

    //  verifica se a quantidade é válida
    console.log(_$form.find('input[name="quantity"]').val());
    if (_$form.find('input[name="quantity"]').val() <= 0) {
      console.log("qtd invalida");
      validated = false;
      errorsTxt.push("Quantidade indisponível");
    }

    return { validated: validated, errors: errorsTxt };
}

// ===============================================================
// SET RESP VALIDATE PRODUCT
// ===============================================================
export function setRespValidateProduct(_resp, _$form, _$boxResponse){
  // var $boxResult = _$form.find('.resp-validate');
  var $boxResult = _$boxResponse;
  var htmlErrors = "";

  if (_resp.validated) {
    $boxResult.empty();
  } else {
    for (var i = _resp.errors.length - 1; i >= 0; i--) {
      htmlErrors += '<span class="msg error">' + _resp.errors[i] + "</span>";
    }

    $boxResult.html(htmlErrors);
    setTimeout(function () {
      $boxResult.html("");
    }, 4000);
  }
}